import { FC } from 'react';
import UserManagementView from './UserManagementView';

const UserManagementHandler: FC = () => {
    return <UserManagementView />;
};

export default UserManagementHandler;
